<template>
  <div class="fetcher">
    <div class="counter">
      Events: {{ events.length }}
    </div>
    <div href="#" @click="loadMore()" class="more">
      more
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: 'Fetcher',
  computed: {
    ...mapState([
      'events'
    ])
  },
  methods: {
    ...mapActions([
      'loadMore'
    ])
  }
}
</script>

<style scoped>

.fetcher {
  margin-bottom: 30px;
}

.more {
  margin-top: 5px;
  color: #757575;
  border-bottom: 1px solid #757575;
  display: inline-block;
  padding: 1px 0;
  cursor: pointer;
}

.more:hover {
  color: #9E9E9E;
  border-bottom: 1px solid #9E9E9E;
}

</style>
